/**
 * Phase 7 Slice B — TanStack Query client.
 *
 * Narrowly scoped to cockpit + ad-spend + campaign-detail pages in Slice B.
 * Other pages keep their existing fetch patterns until later phases roll
 * them in. The defaults here favor zero-latency period switching over
 * always-fresh data — staleTime of 5 minutes means flipping between
 * 7d/30d/90d after the initial load is instant.
 */
import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000,   // 5 minutes
      gcTime: 10 * 60 * 1000,     // 10 minutes
      refetchOnWindowFocus: false,
      retry: 1,
    },
  },
});
